import { Backdrop, Container } from '@loomhq/lens';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import { hideSearchModal } from '../../actions/searchModal';

function Modal(props) {
  const dispatch = useDispatch();
  const maxZIndex = 2147483647;
  const { show } = useSelector(state => state.searchModal);

  const id = 'search-modal-backdrop';

  useEffect(() => {
    const handleUserKeyPress = event => {
      if (event.key == 'Escape') {
        dispatch(hideSearchModal());
      }
    };

    window.addEventListener('keyup', handleUserKeyPress);

    return () => {
      window.removeEventListener('keyup', handleUserKeyPress);
    };
  }, [dispatch]);

  function backdropClick(event) {
    if (event.target.getAttribute('id') === id) {
      dispatch(hideSearchModal());
    }
  }

  return ReactDOM.createPortal(
    <Backdrop isOpen={show} zIndex={maxZIndex}>
      <Container
        id={id}
        onClick={backdropClick}
        height="100%"
        paddingTop="15vh"
      >
        {props.children}
      </Container>
    </Backdrop>,
    document.body
  );
}

export default Modal;
